{
  "organizationLabel": "Organizzazione:",
  "profileDropdownAccountInfoItem": "Informazioni account (interno)",
  "profileDropdownAccountSettingsHeader": "Impostazioni account",
  "profileDropdownProductSettingsHeader": "Impostazioni prodotto",
  "profileDropdownUserSettingsItem": "Preferenze",
  "profileLegalNoticesMenuItem": "Note legali",
  "signOut": "Esci",
  "themeInfoTooltip": "Il tema scuro non è supportato da tutte le applicazioni.",
  "userProfileName": "{firstName} {lastName}",
  "userThemeSwitchLabel": "Tema scuro"
}
